const MuiPaper = (theme) => ({
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        borderRadius: 16,
        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'}`,
      },
      elevation1: {
        boxShadow: theme.palette.mode === 'dark'
          ? '0 4px 24px rgba(0,0,0,0.4)'
          : '0 4px 24px rgba(99,102,241,0.08)',
      },
      elevation2: {
        boxShadow: theme.palette.mode === 'dark'
          ? '0 8px 40px rgba(0,0,0,0.5)'
          : '0 8px 40px rgba(99,102,241,0.12)',
      },
    },
  },
})

export default MuiPaper
